import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Import useNavigate hook for redirection
import customCSS from './Allusers.module.css';
import moment from 'moment';
import { CloseButton } from '../../components/SvgComponents';
import ENV from '../../constants/env-constants';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';
import { formatNumbers } from '../../utils/formatNumbers';

function Allusers() {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedUserInformation, setSelectedUserInformation] = useState(null)
  const rowsPerPage = 10; // Set rows per page
  const navigate = useNavigate(); // Instantiate useNavigate hook
  const location = useLocation()

  // Fetch users from backend API
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Admin All-Users Page' });
    const fetchUsers = async () => {
      const response = await fetch(`${ENV.API_URL}/api/allusers`);
      const data = await response.json();
      setUsers(data);
    };

    fetchUsers().catch(console.error);
  }, []);

  function setUserInformationToShow(userDetails) {
    setSelectedUserInformation({
      firstName: userDetails.firstName || 'NA',
      lastName: userDetails.lastName || 'NA',
      companyOrOrganization: userDetails.companyOrOrganization || 'NA',
      country: userDetails.country || 'NA',
      zipcode: userDetails.zipcode || 'NA',
      email: userDetails.email || 'NA',
      totalAmountDonated: userDetails.totalAmountDonated,
      userSignedUpDate: getFormattedUserSignUpDate(userDetails.userSignedUpTimestamp) || 'NA',
      numberofTimesDonated: userDetails.numberofTimesDonated
    });
  }
  function closeUserInformationModal() {
    setSelectedUserInformation(null)
  }
  function getFormattedUserSignUpDate(timestamp) {
    const parsedDate = moment(timestamp);
    if (parsedDate.isValid()) {
      return moment(timestamp).format("D MMMM YYYY")
    } else return null;
  }
  // Calculate the current rows to display
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = users.slice(indexOfFirstRow, indexOfLastRow);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total pages
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(users.length / rowsPerPage); i++) {
    pageNumbers.push(i);
  }

  // Function to handle redirect to user transactions
  const redirectToUserTransactions = (userId) => {
    navigate(`/admindashboard/usertransactions/${userId}`);
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <Helmet>
          <meta charSet="utf-8" />
          <title>All-Users</title>
        </Helmet>
        <div className={`layout-container ${customCSS.maincontainer}`}>
          <h1 className={customCSS.heading}>All Users</h1>

          <div className={customCSS.layoutWrapper}>
            <div className={customCSS.layoutContainer}>
              <div className={customCSS.tableWrapper}>
                <table className={customCSS.table}>
                  <thead>
                    <tr>
                      <th className={customCSS.th}>Email</th>
                      <th className={customCSS.th}>Total amount donated</th>
                      <th className={customCSS.th}>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRows.map((user) => (
                      <tr onClick={()=>setUserInformationToShow(user)} style={{cursor: "pointer"}} key={user.id}>
                        <td className={customCSS.td}>{user.email}</td>
                        <td className={customCSS.td}>${formatNumbers(user.totalAmountDonated)}</td>
                        <td className={customCSS.td}>
                          <button className={customCSS.detailsButton} onClick={() => redirectToUserTransactions(user.id)}>
                            Details
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {selectedUserInformation ?
                            <div style={{
                                width: '100%', height: '100%',
                                position: 'fixed', display: 'flex',
                                top: '0', right: '0',
                                justifyContent: 'center', alignItems: 'center',
                                backgroundColor: '#00000040'
                              }}>
                              <div style={{
                              backgroundColor: 'whitesmoke',
                              border: "2px solid green",
                              width: 'auto', height: 'auto',
                              display: 'flex', justifyContent: 'center', flexDirection: 'column',
                              padding: '3rem 5rem', borderRadius: '1rem',
                              position: 'relative'
                              }}>
                                <span onClick={closeUserInformationModal} style={{color: 'green', height: '1.5rem', display: 'flex', position: 'absolute', top: '0.3rem', right: '0.3rem', cursor: 'pointer'}}><CloseButton/></span>
                                <div> <strong>First Name:</strong> <span style={{color: 'green'}}>{selectedUserInformation.firstName}</span> </div>
                                <div> <strong>Last Name:</strong> <span style={{color: 'green'}}>{selectedUserInformation.lastName}</span> </div>
                                <div> <strong>Email:</strong> <span style={{color: 'green'}}>{selectedUserInformation.email}</span> </div>
                                <div> <strong>Company/Organization:</strong> <span style={{color: 'green'}}>{selectedUserInformation.companyOrOrganization}</span> </div>
                                <div> <strong>Country:</strong> <span style={{color: 'green'}}>{selectedUserInformation.country}</span> </div>
                                <div> <strong>Zipcode:</strong> <span style={{color: 'green'}}>{selectedUserInformation.zipcode}</span> </div>
                                <div> <strong>Total Donation:</strong> <span style={{color: 'green'}}>${formatNumbers(selectedUserInformation.totalAmountDonated)}</span> </div>
                                <div> <strong>Date Of Sign Up:</strong> <span style={{color: 'green'}}>{selectedUserInformation.userSignedUpDate}</span> </div>
                                <div> <strong>Number of times donated:</strong> <span style={{color: 'green'}}>{selectedUserInformation.numberofTimesDonated}</span> </div>
                            </div>
                            </div>
                            :
                            null
                }
              </div>

              <div className={customCSS.pagination}>
                {pageNumbers.map(number => (
                  <button key={number} onClick={() => paginate(number)} className={customCSS.pageLink}>
                    {number}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Allusers;
